var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.991%",
    y1: "-.011%",
    x2: ".01%",
    y2: "100.01%",
    id: "kotlin__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E44857",
    offset: ".344%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C711E1",
    offset: "46.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F52FF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kotlin__a)",
    d: "M256 256H0V0h256L128 127.949z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.4da7a2794e29231ba86ac6f7c3a0417b.svg";
export { ForwardRef as ReactComponent };